import { createAsyncThunk } from '@reduxjs/toolkit';
import ApiaApi from '../../../api/apiaApi/apiaApi';
import { notify } from '../../../components/common/notifications/util';
import { makeGridActionUrl } from '../actionsUtils';
import { TApiaXMLResponse, TDataGridThunkState } from '../types';
import { shouldDebugGridActions } from './add';
import { TRowActionResponse } from './types';

const clearGrid = createAsyncThunk<
  TRowActionResponse | null,
  {
    gridId: string;
  },
  TDataGridThunkState
>('dataGridSlice/clearGrid', async ({ gridId }, thunkApi) => {
  const state = thunkApi.getState().dataGridSlice[gridId];
  const result = await ApiaApi.post<TApiaXMLResponse>(
    makeGridActionUrl({
      gridAction: 'clearGrid',
      context: state.context,
    }),
  );
  if (shouldDebugGridActions) console.log('clearGrid', result?.data);
  if (result?.data)
    return {
      xmlResponse: result?.data,
      focusRow: state.focusedRow,
      newSelectedRows: state.selectedRows,
      focusColumn: state.focusedColumn,
    };

  notify({
    message: 'Error on DataGrid action',
    type: 'danger',
  });
  return null;
});

export default clearGrid;
